globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modules.Reviews = appCustomerSpace.Modules.Reviews || {};

appCustomerSpace.Modules.Reviews.Reply = (function() {

  function Reply() {
    this.$body = $('body');
    this.init();
  }

  Reply.prototype = {
    init: function(){
      this.$buttonsReply = this.$body.find('.btn-review-reply');
      this.$buttonsUpdateReply = this.$body.find('.btn-review-update-reply');
      this.$buttonsDeleteReplySuggestion = this.$body.find('.btn-review-delete-reply-suggestion');
      this.$buttonsGenerateReplySuggestionWithAi = this.$body.find('.btn-review-generate-reply-suggestion-with-ai');

      this.$buttonsReply.on('click', function(e) {
        e.preventDefault();

        var $this = $(this),
            $reviewReplyForm = $this.closest('.review-item-thumbnail').find('.review-reply-form');

        $reviewReplyForm.show().find('.reply-comment-textarea').focus();
        $this.hide();
      });

      this.$buttonsUpdateReply.on('click', function(e) {
        e.preventDefault();

        var $this = $(this),
            $reviewReplyForm = $this.closest('.review-item-thumbnail').find('.review-reply-form');

        $reviewReplyForm.show().find('.reply-comment-textarea').focus();
        $this.closest('.review-reply-wrapper').find('.review-reply-content').hide();
      });

      this.$buttonsDeleteReplySuggestion.on('click', function(e) {
        e.preventDefault();

        var $this = $(this),
            $reviewReplyWrapper = $this.closest('.review-reply-wrapper'),
            $reviewReplyForm = $this.closest('.review-item-thumbnail').find('.review-reply-form'),
            url = $this.data('url');

        appCustomerSpace.Loader().start({ $container: $reviewReplyWrapper, options: {text: false, style: { backdrop: { background: 'rgb(255,255,255,0.8)' }}} });

        if (url) {
          $.ajax({
            url: url,
            type: 'PATCH',
            success: function(data)
            {
              if (data.response == 1) {
                appCustomerSpace.Loader().stop({ $container: $reviewReplyWrapper });

                $reviewReplyWrapper.find('.review-reply-content').hide();
                $reviewReplyForm.replaceWith(data.html);
                $this.closest('.review-item-thumbnail').find('.review-reply-form').show().find('.reply-comment-textarea').focus();

                appCustomerSpace.Modules.Reviews.Reply.init();

                appCustomerSpace.Plugins.initPlugins();
                appCustomerSpace.LimitlessPlugins.initPlugins();
              } else {
                appCustomerSpace.Loader().stop({ $container: $reviewReplyWrapper });
                alert('Une erreur est survenue');
              }
            }
          });
        }
      });

      this.$buttonsGenerateReplySuggestionWithAi.on('click', function(e) {
        e.preventDefault();

        var $this = $(this),
            $reviewItemThumbnail = $this.closest('.review-item-thumbnail'),
            $reviewReplyForm = $reviewItemThumbnail.find('.review-reply-form'),
            url = $this.data('url');

        appCustomerSpace.Loader().start({ $container: $reviewReplyForm, options: {text: false, style: { backdrop: { background: 'rgb(255,255,255,0.8)' }}} });

        if (url) {
          $.ajax({
            url: url,
            type: 'PATCH',
            success: function(data)
            {
              if (data.response == 1) {
                appCustomerSpace.Loader().stop({ $container: $reviewReplyForm });

                $reviewReplyForm.replaceWith(data.html);

                var $newReviewReplyForm = $reviewItemThumbnail.find('.review-reply-form');
                $newReviewReplyForm.show()
                $newReviewReplyForm.find('.reply-comment-textarea').focus();

                appCustomerSpace.Modules.Reviews.Reply.init();

                appCustomerSpace.Plugins.initPlugins();
                appCustomerSpace.LimitlessPlugins.initPlugins();
              } else {
                appCustomerSpace.Loader().stop({ $container: $reviewReplyForm });
                alert('Une erreur est survenue');
              }
            }
          });
        }
      });
    }
  }

  return Reply;
})();
